import { APPROVEMENTS_DRIVER } from './actions/approvements'
import {
  GET_DRIVERS,
  GET_DRIVERS_FAIL,
  GET_DRIVERS_REQUEST,
  GET_DRIVERS_SUCCESS,
  GET_FILTER_DRIVERS,
  UPDATE_DRIVER,
  UPDATE_DRIVERS,
} from './actions/drivers'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { mutateEntity } from '@/helpers/store'

const Driver = RepositoryFactory.get('driver')
const approvementsApi = RepositoryFactory.get('approvements')
const SET_LOADING_STATS = 'SET_LOADING_STATS'
const FETCH_DRIVERS_STATS = 'FETCH_DRIVERS_STATS'

export default {
  namespaced: true,
  state: {
    drivers: [],
    pagination: {},
    loading: false,
    loadingStats: false,
    approvStatistics: {},
  },
  getters: {
    getDrivers: state => state.drivers,
    getLoading: state => state.loading,
    getPagination: state => state.pagination,
    getDriversById(state) {
      return id => state.drivers.find(item => Number(item.id) === Number(id))
    },
  },
  actions: {
    [APPROVEMENTS_DRIVER]: ({ commit }, data) => {
      commit(APPROVEMENTS_DRIVER, data)
    },
    [GET_DRIVERS]: ({ commit }, { page, status }) => {
      commit(GET_DRIVERS_REQUEST)
      Driver.getDriver(page, status)
        .then(res => {
          const drivers = res.data.items
          const pagination = res.data._meta

          commit(GET_DRIVERS_SUCCESS, { drivers, pagination })
        })
        .catch(() => commit(GET_DRIVERS_FAIL))
    },
    [GET_FILTER_DRIVERS]: ({ commit }, search) => {
      commit(GET_DRIVERS_REQUEST)
      Driver.getFilterDriver(search)
        .then(res => {
          const drivers = res.data.items
          const pagination = res.data._meta

          commit(GET_DRIVERS_SUCCESS, { drivers, pagination })
        })
        .catch(() => commit(GET_DRIVERS_FAIL))
    },
    async fetchDriversStats({ commit }) {
      commit(SET_LOADING_STATS, true)
      try {
        const { data } = await approvementsApi.fetchApprovements('drivers')

        commit(FETCH_DRIVERS_STATS, data.by_meaning)
      } catch (error) {
        // eslint-disable-next-line
        console.log(`error `, error)
      } finally {
        commit(SET_LOADING_STATS, false)
      }
    },
  },
  mutations: {
    [APPROVEMENTS_DRIVER]: (state, data) => {
      let newStateData = mutateEntity(state.drivers, data)

      if (newStateData instanceof Object) {
        state.drivers[newStateData.index] = Object.assign(
          {},
          newStateData.newState,
        )
      }
    },
    [UPDATE_DRIVERS]: (state, drivers) => {
      state.drivers = drivers
    },
    [GET_DRIVERS_REQUEST]: state => {
      state.loading = true
    },
    [GET_DRIVERS_SUCCESS]: (state, { drivers, pagination }) => {
      state.drivers = drivers
      state.pagination = pagination
      state.loading = false
    },
    [GET_DRIVERS_FAIL]: state => {
      state.loading = false
    },
    [UPDATE_DRIVER]: (state, { id, driver }) => {
      const index = state.drivers.findIndex(i => i.id === id)

      state.drivers[index] = { ...state.drivers[index], ...driver }
    },
    [SET_LOADING_STATS](state, payload) {
      state.loadingStats = Boolean(payload)
    },
    [FETCH_DRIVERS_STATS](state, payload) {
      state.approvStatistics = payload
    },
  },
}
